import { GUEST_PROPOSALS_PATH, ROUTES } from '../../../Constants'

export const shouldRedirectToLoginPage = (pathname: string): boolean => {
  const { EVENT_HUB } = ROUTES

  const ROUTES_REQUIRE_AUTHENTICATION = [EVENT_HUB]

  const pathSegments = pathname !== '' ? pathname.split('/') : []

  let routesRequiringAuthenticationWithAppendedSegment: string[] = []

  if (
    pathSegments.length > 1 &&
    '/' + pathSegments[1] === GUEST_PROPOSALS_PATH
  ) {
    routesRequiringAuthenticationWithAppendedSegment =
      ROUTES_REQUIRE_AUTHENTICATION.map(
        (route) => GUEST_PROPOSALS_PATH + route
      )
  } else {
    routesRequiringAuthenticationWithAppendedSegment =
      ROUTES_REQUIRE_AUTHENTICATION
  }

  const formattedPathname = pathname.endsWith('/') ? pathname : pathname + '/'

  return routesRequiringAuthenticationWithAppendedSegment.includes(
    formattedPathname
  )
}
